import React, {useEffect, useState} from "react";
import * as axios from "axios";
import {Dialog, IconButton, Button, TextField} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "./styles.css";

const baseUrl = 'https://api.appetito.ro/';

// "Inventar": how many of each physical "Roata" prize (e.g. Pepsi) the
// deliverer carries to hand out with orders. Separate from the wheel's own
// stock (Setări > Roata); the app takes one off per delivered prize order,
// and it can go negative. Personal.js keys it on the deliverer, so every
// open starts fresh.
export default function InventoryModal({open, deliverer, onClose}) {
  const [items, setItems] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !deliverer) {
      return;
    }
    const token = localStorage.getItem('access_token');
    axios.default.get(`${baseUrl}v1/admin/deliverer/${deliverer.id}/inventory`, {
      headers: {Authorization: `Bearer ${token}`},
    }).then((response) => {
      const list = response.data || [];
      setItems(list);
      setQuantities(Object.fromEntries(list.map((item) => [item.item_id, String(item.quantity)])));
    }).catch(() => setError('Eroare la încărcarea inventarului.'));
  }, [open, deliverer]);

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      const token = localStorage.getItem('access_token');
      const payload = {
        items: items.map((item) => ({
          item_id: item.item_id,
          quantity: parseInt(quantities[item.item_id], 10) || 0,
        })),
      };
      await axios.default.put(`${baseUrl}v1/admin/deliverer/${deliverer.id}/inventory`, payload, {
        headers: {Authorization: `Bearer ${token}`},
      });
      onClose();
    } catch (e) {
      setError('Eroare la salvare.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <div className="deliverer-modal">
        <div className="deliverer-modal-topbar">
          <h3 className="deliverer-modal-title">
            Inventar{deliverer ? ` — ${deliverer.first_name} ${deliverer.last_name}` : ''}
          </h3>
          <IconButton className="deliverer-modal-close" size="small" onClick={onClose}>
            <CloseIcon/>
          </IconButton>
        </div>
        <p className="deliverer-inventory-hint">
          Premiile fizice de la Roată pe care le are livratorul. Scade automat cu 1 la fiecare comandă livrată cu premiu.
        </p>

        <div className="deliverer-inventory-list">
          {items === null && !error && <div className="deliverer-inventory-empty">Se încarcă...</div>}
          {items && items.length === 0 && (
            <div className="deliverer-inventory-empty">Nu există premii fizice în Setări &gt; Roata.</div>
          )}
          {items && items.map((item) => (
            <div key={item.item_id} className="deliverer-inventory-row">
              {item.image
                ? <img className="deliverer-inventory-image" src={item.image} alt=""/>
                : <div className="deliverer-inventory-image"/>}
              <span className="deliverer-inventory-label">{item.label}</span>
              <TextField
                type="number"
                label="Bucăți"
                value={quantities[item.item_id] ?? ''}
                onChange={(event) => setQuantities({...quantities, [item.item_id]: event.target.value})}
                margin="dense"
                className="deliverer-inventory-qty"
                inputProps={{step: 1}}
              />
            </div>
          ))}
        </div>

        {error && <div className="deliverer-modal-error">{error}</div>}

        <div className="deliverer-modal-footer">
          <Button onClick={onClose} disabled={saving}>Anulează</Button>
          <Button onClick={save} disabled={saving || !items} variant="contained" color="primary">
            Salvează
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
